import { MyJoi } from "@sr-partner-portal/common";

const languageValidationSchema = MyJoi.object({
    language: MyJoi.myString().min(3).max(100).required(),
    level: MyJoi.number()
        .integer()
        .min(0)
        .max(5)
        .empty("", "null")
        .default(0),
}).required();

export { languageValidationSchema };
